import React, { useContext } from "react";
import PropTypes from "prop-types";

import Button from "./Button";
import { WidgetContext } from "./WidgetContext";
import { useBreakpoint } from "./WidgetBreakpoint";

import { Colours } from "@learningblocks/shared-components";

import dialog from "./img/dialog.svg";
import dialog_sm from "./img/dialog-sm.svg";

import close from "./img/close.svg";

export default function Dialog(props) {
  // Include the widget providers
  const breakpoints = useBreakpoint();
  const widget = useContext(WidgetContext);

  return (
    <div
      className={props.type}
      style={{
        display: !widget.displayIntro ? "none" : "flex",
        position: "absolute",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.8)",
        zIndex: 99,
      }}
    >
      <div
        style={{
          background: "white",
          maxWidth: "800px",
          margin: breakpoints.sm ? "8px" : "32px",
          height: "auto",
          borderRadius: "5px",
          overflowY: "scroll",
        }}
      >
        <div
          className="Dialog-head"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button type="Close" onClick={() => widget.setDisplayIntro(false)}>
            <p
              style={{
                color: Colours.navy1,
                margin: "1px 0 0",
                paddingRight: "4px",
              }}
            >
              Close
            </p>
            <img src={close} alt="Close icon." />
          </Button>
        </div>
        <div
          className="Dialog-body"
          style={{ padding: !breakpoints.sm ? "32px" : "0 16px 16px" }}
        >
          <div
            className="Cover-image"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <img
              src={!breakpoints.sm ? dialog : dialog_sm}
              alt="DNA helicies."
            />
          </div>
          <h1
            style={{
              textAlign: "center",
              color: Colours.charcoal1,
              marginBottom: "12px",
              fontSize: breakpoints.sm
                ? "22px"
                : breakpoints.md
                  ? "32px"
                  : null,
            }}
          >
            One DNA copy to a billion - the amplifying power of PCR.
          </h1>
          <p
            style={{
              textAlign: "center",
              margin: !breakpoints.sm ? "0 0 32px" : "0 0 16px",
            }}
          >
            {!breakpoints.sm
              ? "Polymerase Chain Reaction (PCR) is used to amplify a particular segment of DNA (the desired region) so that we generate a usable amount from a small starting sample. Typically, PCR includes ~30 cycles of denaturation, annealing, and elongation steps. If we imagine starting with one DNA copy, we can determine the number of copies of total DNA and desired region DNA after each cycle."
              : "Polymerase Chain Reaction (PCR) is used to amplify a particular segment of DNA (the desired region)."}
          </p>
          <div
            className="Dialog-call-to-action"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              type="Primary"
              onClick={() => widget.setDisplayIntro(false)}
            >
              Begin
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
Dialog.PropTypes = {
  type: PropTypes.string,
  display: PropTypes.boolean,
};
